import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

type Tone = "primary" | "accent" | "secondary" | "neutral" | "danger" | "success";

const tones: Record<Tone, string> = {
  primary: "bg-primary-100 text-primary-900 border-primary-200",
  accent: "bg-accent-100 text-accent-900 border-accent-300",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
  neutral: "bg-background-100 text-foreground-700 border-background-200",
  danger: "bg-primary-100 text-primary-800 border-primary-300",
  success: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

interface BadgeProps {
  children: ReactNode;
  tone?: Tone;
  icon?: string;
  className?: string;
}

export default function Badge({ children, tone = "neutral", icon, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-label font-medium whitespace-nowrap",
        tones[tone],
        className
      )}
    >
      {icon && <i className={cn(icon, "text-[13px]")} aria-hidden="true" />}
      {children}
    </span>
  );
}